import { SpacesFeature } from '@/shared/types/Settings';

export const getUpgradeAlertText = ({ enabled, metadata }: SpacesFeature, extraSeats = 0) => {
  const userLimit = metadata?.user_limit ?? 0;

  if (!enabled && !extraSeats) return 'Invite users to collaborate';

  // Минимум 1 место всегда под владельца; extra seats добавляются сверх этого
  const totalSeats = Math.max(userLimit, 1) + extraSeats;
  return `Up to ${totalSeats} members available on your plan`;
};
